// @flow
/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';

import { useStaticAssetPath } from '../StaticAssetProvider';

type Props = {
  /** Video Src */
  src: string,
};

const StaticVideo = ({ src, ...props }: Props) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();

  return (
    <video src={buildStaticAssetUrl(src)} type="video/mp4" {...props}>
      Your browser does not support HTML5 video.
    </video>
  );
};

export default StaticVideo;
